<div class="checkbox-filter-dropdown"
     role="dialog"
     [attr.aria-label]="title"
     (pointerdown)="$event.stopPropagation()"
     (mousedown)="$event.stopPropagation()"
     (mouseup)="$event.stopPropagation()"
     (click)="$event.stopPropagation()">
    <div class="filter-toolbar">
        <span class="filter-title">{{ title }}</span>
        <span class="filter-summary">{{ summaryText }}</span>
    </div>

    <div class="filter-search" *ngIf="searchEnabled">
        <input type="search"
               class="form-control form-control-sm"
               [placeholder]="searchPlaceholder"
               [attr.aria-label]="searchPlaceholder"
               [(ngModel)]="search">
    </div>

    <div class="filter-bulk-row" *ngIf="options.length > 0">
        <label class="filter-select-all-control">
            <input type="checkbox"
                   [checked]="allFilteredSelected"
                   [indeterminate]="someFilteredSelected"
                   [disabled]="filteredOptions.length === 0"
                   [attr.aria-label]="selectAllCheckboxText"
                   (change)="setFilteredSelection($any($event.target).checked)">
            <span>{{ selectAllCheckboxText }}</span>
        </label>
        <button type="button"
                class="filter-clear-btn"
                [disabled]="!canClearFilter"
                (click)="clearFilter()">Clear filter</button>
    </div>

    <div class="filter-options">
        @for (option of filteredOptions; track option.value) {
            <div class="filter-option">
                <label>
                    <input type="checkbox"
                           [checked]="isSelected(option.value)"
                           (change)="toggleOption(option.value)">
                    <span>{{ option.label }}</span>
                </label>
            </div>
        }
        @if (filteredOptions.length === 0) {
            <div class="filter-empty text-muted small">
                {{ options.length === 0 ? emptyText : noMatchesText }}
            </div>
        }
    </div>
</div>
